import { API_ROUTE } from "../../../utils/constants.js";
import { baseApi } from "../baseApi.js";
import { getToken } from "../localStorageService.js";

export const staffApi = baseApi.injectEndpoints({
  credentials: "include",
  endpoints: (builder) => ({
    addStaff: builder.mutation({
      query: (user) => {
        return {
          url: API_ROUTE.addStaff,
          method: "POST",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    getStaffs: builder.query({
      query: ({ search, limit, page, user_role = "client", client_id }) => {
        let query = `${API_ROUTE.getStaffs}/${user_role}/get-staff?search=${search}&limit=${limit}&page=${page}`;
        if (client_id) {
          query += `&client_id=${client_id}`;
        }
        return {
          url: query,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
    }),
    updateStaff: builder.mutation({
      query: (user) => {
        return {
          url: `${API_ROUTE.updateStaff}/${user.id}`,
          method: "PATCH",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: getToken(),
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    deleteStaff: builder.mutation({
      query: (user) => {
        return {
          url: `${API_ROUTE.deleteStaff}/${user.id}`,
          method: "DELETE",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
  }),
});

export const {
  useAddStaffMutation,
  useGetStaffsQuery,
  useUpdateStaffMutation,
  useDeleteStaffMutation,
} = staffApi;
